import { Testimonial } from '@app/core/interfaces';

export const TESTIMONIALS_CAPGO: Testimonial[] = [
  {
    company: {
      imgSrc: '/assets/images/logos/clovis.svg',
      name: 'Clovis',
    },
    person: {
      imgSrc: '/assets/images/testimonials/clement-fradet-normand.jpg',
      name: 'Clément Fradet Normand',
      position: 'Co-Founder',
    },
    quote: [
      "We switched from Capgo to Capawesome Cloud a few months ago and so far we haven't looked back.",
      'With Capawesome Cloud, we have significantly less downtime, updates are delivered faster, and <b>support is literally the best we have ever experienced</b>.',
      'The integration was straightforward, and the documentation is clear and concise.',
      'Big thanks to the Capawesome team for creating such an awesome platform!',
    ].join(' '),
  },
  {
    company: {
      imgSrc: '/assets/images/logos/summon-worlds.png',
      name: 'Summon Worlds',
      url: 'https://www.summonworlds.com/',
    },
    person: {
      imgSrc: '/assets/images/testimonials/jedidiah-weller.jpg',
      name: 'Jedidiah Weller',
      position: 'World Builder',
    },
    quote: [
      'We mainly use over-the-air (OTA) updates to deliver critical bug fixes and updates when waiting on the App Store review process is not an option.',
      "After dealing with too much down-time and latency from Capgo, we made the decision to switch to Capawesome Cloud and we couldn't be happier.",
      '<b>Capawesome is more stable and the package delivery speeds are significantly faster</b>, which makes a big difference at scale.',
      "Capawesome's team is extremely responsive and professional - thanks for supplying such a great product guys.",
    ].join(' '),
  },
];

export const TESTIMONIALS: Testimonial[] = [
  {
    company: {
      imgSrc: '/assets/images/logos/snapaddy.svg',
      name: 'snapADDY GmbH',
    },
    person: {
      imgSrc: '/assets/images/testimonials/michael-wolz.png',
      name: 'Michael Wolz',
      position: 'Head of Development',
    },
    quote: [
      'Capawesome Cloud has helped us <b>reduce our live update costs by more than 90%</b> while offering more features than our previous provider.',
      'The integration took us less than a day and the support is top-notch.',
      'We now deliver daily live updates to more than 200,000 devices without any issues.',
    ].join(' '),
  },
  {
    company: {
      imgSrc: '/assets/images/logos/vitruve.webp',
      name: 'Vitruve',
    },
    person: {
      imgSrc: '/assets/images/testimonials/hugo-corta.jpg',
      name: 'Hugo Corta',
      position: 'Tech Lead',
    },
    quote: [
      'Capawesome Cloud has been a game-changer for our team.',
      'We can now deploy updates to our Capacitor app without pushing to the app stores.',
      'This has saved us countless hours and allowed us to iterate faster.',
      "It's a <b>must-have for any modern app development team</b>.",
    ].join(' '),
  },
  {
    company: {
      imgSrc: '/assets/images/logos/nuinalp.png',
      name: 'Nuinalp',
    },
    person: {
      imgSrc: '/assets/images/testimonials/patrick-a-lima.jpg',
      name: 'Patrick A. Lima',
      position: 'CEO',
    },
    quote: [
      'We tested and verified several solutions on the market to help us deliver OTA updates for our Apps quickly, securely and, most importantly, that were capable of scaling as we grew and demanded.',
      'Capawesome Cloud was our choice! <b>The integration is super simple, we have automatic rollback and code signing to ensure the security of updates</b>.',
      'The costs are transparent and honest, we are very happy with the platform and looking forward to integrating our future Apps!',
    ].join(' '),
  },
  {
    company: {
      imgSrc: '/assets/images/logos/our-management-group.webp',
      name: 'Our Management Group Pty Ltd',
      url: 'https://www.ourmanagement.com/',
    },
    person: {
      name: 'Karvan Jay',
      position: 'Technical Director',
    },
    quote: [
      'Moving from Ionic Appflow to Capawesome Cloud has been a fantastic experience.',
      "We're very pleased with the product and genuinely impressed with what the team has built.",
      'The <b>builds are significantly faster than Ionic Appflow</b>, which is a nice improvement.',
      'We especially appreciate how the build process is separated from deployment—it has made debugging much easier and streamlined our entire workflow.',
      'The support has also been great. We hope to see even more users make the switch!',
    ].join(' '),
  },
  ...TESTIMONIALS_CAPGO,
];
